import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { DptmasterService } from 'src/app/services/dptmaster.service';
import { DeviceService } from 'src/app/services/device.service';
import { DivisionService } from 'src/app/services/division.service';
import { AlertService } from 'src/app/services/alert.service';
import { InputformatService } from 'src/app/services/inputformat.service';

@Component({
  selector: 'app-power-source-componentassign',
  templateUrl: './power-source-componentassign.component.html',
  styleUrls: ['./power-source-componentassign.component.scss']
})

export class PowerSourceComponentassignComponent implements OnInit {
  @Input() actionId: any;
  @Input() resultdata: any;
  @Output() backComp = new EventEmitter<any>();
  valuesForm!: FormGroup;
  value: any;
  compVal: any[] = [];
  selectedValue: any[];
  id: any;
  GetByIdResponse: any;
  filtercompVal: any[];

  constructor
    (
      private fb: FormBuilder,
      private location: Location,
      private dptmasterservice: DptmasterService,
      private divisionService: DivisionService,
      private alertService: AlertService,
      private inputFormatService : InputformatService
    ) { }

  ngOnInit(): void {
    this.id = this.resultdata.id ? this.resultdata.id : 0
    this.initializeForm();
    if (this.id) {
      this.getSchemeLookyp(this.id);
    }
  }



  initializeForm() {
    this.valuesForm = this.fb.group({
      name: new FormControl('', Validators.required),
      // powerSourceId: new FormControl('', Validators.required),
    });
  }


  getSchemeLookyp(id: number) {
    this.dptmasterservice.getPowerSourcebyId(id).subscribe((res) => {
      this.GetByIdResponse = res

      if (this.GetByIdResponse) {
        this.valuesForm.patchValue({
          name: res.name,
          // powerSourceId: res.powerSourceId,
        });
      }
    })
  }


  getLookup() {
    this.dptmasterservice.powerSourceLookup().subscribe((res) => {
      this.compVal = res
      this.filtercompVal = this.compVal.slice();
    })
  }


  back() {
    const msg = { show: true };
    this.backComp.emit(msg);
  }

  Update() {
    if (this.valuesForm.valid) {

      let data = {
        "id": this.id,
        "name": this.valuesForm.value.name,
        // "powerSourceType": this.valuesForm.value.powerSourceId
      }
      this.dptmasterservice.powerSourcePost(data).subscribe((res) => {
        if (res.isSuccess) {
          this.alertService.success(this.actionId==0 ? 'Power Source Saved Successfully':this.actionId==1 ?  'Power Source Updated Successfully':'');
          this.back()
        }
      })
    }
    else{
      this.valuesForm.markAllAsTouched();
    }
  }
  onInput(event: any, regexPattern: any): void {
    this.inputFormatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }

}